import { Component } from "../../core/Component";
export class NavTopQuizComponent extends Component {
  constructor($root, options) {
    // console.log(options.messages);
    super($root, options);
    this.formId = options.formId;
    this.quizWrapperId = options.quizWrapperId;
    this.quizPicture = options.quizPicture;
    this.quizPicturePosition = options.quizPicturePosition;
    this.formIndex = options.formIndex;
    this.blockQuantity = options.blockQuantity;
    this.blockTitle = options.blockTitle || false;
    this.activeTab = 0;
    this.completeTab = [];
    this.theme = null;
    this.messages = options.messages;
    this.useDesign = options.useDesign;
    this.rootId = `${this.formId}_${this.formIndex}_tabnav-here`;
    this.$root.$el.id = this.rootId;
    this.navId = `${this.formId}_${this.formIndex}_nav`;
    this.$frame = document.createElement("iframe");
    this.$frame.style.position = "absolute";
    this.$frame.style.top = 0;
    this.$frame.style.left = 0;
    this.$frame.style.width = "100%";
    this.$frame.style.height = "100%";
    this.$frame.style.zIndex = "-11111";
    this.$frame.style.border = "none";
    this.size = 0;
    this.blockNavStyle = options.blockNavStyle /* [0] || "2" */;
  }

  toHTML() {
    let str = '';
    if (this.blockNavStyle[0] === "0") {
      str += `<div class="qform_tab-nav" id="${this.navId}">`;
      for (let i = 0; i < this.blockQuantity; i++) {
        str += `
          <div
            class="qform_tab-nav__item 
            ${this.activeTab === i ? "active" : this.completeTab.includes(i) ? "complete" : ""}"
            data-tab-id="${i}"
          >
            <div class="qform_tab-nav__title">
              <i></i>
              <span>${this.messages.step} ${i + 1}</span>
            </div>
          </div>
        `;
      }
      str += `</div>`;
    } else {
      str += `<div class="qform_line-nav" id="${this.navId}">`;
      if (!this.blockTitle) {
        str += `
        <div class="qform_line-nav__step">
          ${this.messages.step} ${this.completeTab.length + 1}/<span>${this.blockQuantity}</span>
        </div>`;
      }
      str += `
        <div class="qform_line-nav__title">${this.blockTitle || ""}</div>
        <div class="qform_line-nav__box">
      `;
      str += `<div class="qform_line-nav__bar">`;
      for (let i = 0; i < this.blockQuantity; i++) {
        str += `<div
            class="qform_line-nav__item 
            ${this.activeTab === i ? "active" : this.completeTab.includes(i) ? "complete" : ""}"
          ></div>
        `;
      }
      str += `
        </div>
          <div class="qform_line-nav__step-all">
            ${this.completeTab.length + 1}/
            <span>${this.blockQuantity}</span>
          </div>`;
      str += `</div> </div>`;
    }
    this.$root.$el.innerHTML = str;
    return str;
  }
  toHtmlStep() {
    let $nav = this.$root.$el.querySelector(`#${this.navId}`);
    if ($nav) {
      let str = "";
      if (this.blockNavStyle[0] === "0") {
        for (let i = 0; i < this.blockQuantity; i++) {
          str += `
            <div
              class="qform_tab-nav__item 
              ${this.activeTab === i ? "active" :
          // : this.completeTab.includes(i)
          this.activeTab > i ? "complete" : ""}"
              data-tab-id="${i}"
            >
              <div class="qform_tab-nav__title">
                <i></i>
                <span>${this.messages.step} ${i + 1}</span>
              </div>
            </div>
          `;
        }
      } else {
        if (!this.blockTitle) {
          str += `
          <div class="qform_line-nav__step">
          ${this.messages.step} ${this.completeTab.length + 1}/<span>${this.blockQuantity}</span>
          </div>`;
        }
        str += `
          <div class="qform_line-nav__title">${this.blockTitle || ""}</div>
          <div class="qform_line-nav__box">
        `;
        str += `<div class="qform_line-nav__bar">`;
        for (let i = 0; i < this.blockQuantity; i++) {
          str += `<div
              class="qform_line-nav__item 
              ${this.activeTab === i ? "active" :
          // : this.completeTab.includes(i)
          this.activeTab > i ? "complete" : ""}"
            ></div>
          `;
        }
        str += `
          </div>
            <div class="qform_line-nav__step-all">
              ${this.completeTab.length + 1}/
              <span>${this.blockQuantity}</span>
            </div>`;
      }
      $nav.innerHTML = str;
    }
  }
  windowScroll(scrollValue) {
    window.scroll({
      top: scrollValue
    });
  }

  /**
   * @param event {HTMLFormElement}*/
  setQuizViewPosition(event) {
    const $form = event || document.querySelector(`div[data-formid="${this.formId}"]`);
    let scrollValue;

    //если форма на qform.link, всегда скроллить к верху страницы
    if (/qform.link/.test(document.location.host)) {
      this.windowScroll(0);
      return;
    }
    const fromPageY = $form?.getBoundingClientRect().top + window.scrollY;
    //если высота формы меньше высоты области видимости
    if (document.documentElement.clientHeight > $form.clientHeight) {
      // scrollValue = $form.offsetTop - document.documentElement.clientHeight / 2 + $form.offsetHeight / 2
      scrollValue = fromPageY - document.documentElement.clientHeight / 2 + $form?.offsetHeight / 2;
      //высота формы больше области видимости
    } else {
      scrollValue = fromPageY;
    }
    this.windowScroll(scrollValue);
  }
  setActiveTab() {
    let blockIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let current = arguments.length > 1 ? arguments[1] : undefined;
    let blockTitle = arguments.length > 2 ? arguments[2] : undefined;
    let endTab = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    let blockOrder = arguments.length > 4 ? arguments[4] : undefined;
    this.blockTitle = blockTitle || "";
    this.activeTab = blockOrder;
    this.completeTab = [];
    this.completeTab = blockIds.filter(id => id.id !== current);
    this.toHtmlStep();
  }
  setTheme() {
    if (this.theme) {
      this.$root.$el.classList.add(this.theme);
    }
  }
  setStepPictureData(data) {
    this.quizPicture = data.quizPicture;
    this.quizPicturePosition = data.quizPicturePosition;
  }
  init() {
    this.$tabNav = this.$root.$el.querySelector(`#${this.navId}`);
    this.removeEventListenerBtn();
    this.setTheme();
    this.vertical = this.blockNavStyle[1] === "1";
    this.$form = this.$root.$el.parentNode.querySelector("form");
    this.$form.append(this.$frame);
    this.parentForm = this.$form.parentNode;
    this.contentChildren = this.$form.children;
    this.$frame.contentWindow.onresize = this.resize.bind(this);
    this.resize();
    this.$subscribe("setNextTab", this.setActiveTab.bind(this));
    this.Emitter.subscribe("pictureData", data => {
      this.setStepPictureData(data);
    });
    this.Emitter.subscribe("setQuizViewPosition", ev => this.setQuizViewPosition(ev));
    this.$root.$el.classList.add("qform-tabnav-here");
    if (!this.useDesign) {
      this.$root.$el.classList.add("not-styled");
    }
    super.init();
  }
  setClassField(data) {
    // Темная тема формы
    if (data.formStyleCommon && data.formStyleCommon.theme) {
      this.theme = "qform-theme-black";
    }
    if (data.formStyleSteps) {
      this.blockNavStyle[0] = data.formStyleSteps.style.toString();
      this.blockNavStyle[1] = +data.formStyleSteps.position === 1 ? "1" : "0";
      if (!data.formStyleSteps.useDesign) {
        this.useDesign = false;
      }
      this.toHTML();
      this.init();
    }
  }
  removeEventListenerBtn() {
    if (this.$prevBtn) {
      this.$prevBtn.remove();
    }
    if (this.$nextBtn) {
      this.$nextBtn.remove();
    }
    this.$prevBtn = document.createElement("div");
    this.$prevBtn.classList.add(`tabnav-here__prev-btn`);
    this.$nextBtn = document.createElement("div");
    this.$nextBtn.classList.add(`tabnav-here__next-btn`);
    this.$root.$el.insertBefore(this.$prevBtn, this.$root.$el.firstChild);
    this.$root.$el.append(this.$nextBtn);
  }
  resize(e) {
    if (this.$tabNav && this.$tabNav.classList.contains("qform_tab-nav")) {
      let $activeStep = this.$tabNav.querySelector(".active");
      let numStep = $activeStep.dataset.tabId;
      let widthAllForm = this.$form.offsetWidth;
      if (this.vertical) {
        widthAllForm = this.$form.offsetWidth + this.$tabNav.offsetWidth;
      }
      if (this.blockNavStyle[1] === "1") {
        if (widthAllForm < 600) {
          this.parentForm.classList.remove("quiz-nav-vertical");
          this.vertical = false;
          this.removeEventListenerBtn();
          this.$prevBtn.addEventListener("click", this.scrollLeft.bind(this));
          this.$nextBtn.addEventListener("click", this.scrollRight.bind(this));
        } else {
          this.vertical = true;
          this.removeEventListenerBtn();
          this.$prevBtn.addEventListener("click", this.scrollTop.bind(this));
          this.$nextBtn.addEventListener("click", this.scrollBottom.bind(this));
          if (!this.parentForm.classList.contains("quiz-nav-vertical")) {
            this.parentForm.classList.add("quiz-nav-vertical");
          }
        }
      } else {
        this.removeEventListenerBtn();
        this.parentForm.classList.remove("quiz-nav-vertical");
        this.$prevBtn.addEventListener("click", this.scrollLeft.bind(this));
        this.$nextBtn.addEventListener("click", this.scrollRight.bind(this));
      }

      //высота одного элемента блока шагов квиза
      const stepHeight = 115;
      if (this.vertical) {
        let formHeight = 0;
        let stepsSectionHeight = this.$tabNav.children.length * stepHeight;

        //суммируем высоты всех полей в шаге квиза
        for (let i = 0; i < this.contentChildren.length; i++) {
          if (this.contentChildren[i].tagName !== "IFRAME") {
            formHeight += this.contentChildren[i].offsetHeight;
          }
        }
        if (stepsSectionHeight - 200 > formHeight) {
          this.$root.$el.classList.add("tab");
          this.$nextBtn.style.display = "block";
          this.$prevBtn.style.display = "block";
          this.size = (Math.trunc(formHeight / stepHeight) - 1) * stepHeight + 42;
          this.$tabNav.style.height = this.size + "px";
          this.$tabNav.style.overflow = "hidden";
          this.$tabNav.style.marginBottom = 0;
          if (numStep * stepHeight < this.$tabNav.scrollHeight - this.size) {
            this.$tabNav.scrollTop = 35 + numStep * stepHeight;
          } else {
            this.$tabNav.scrollTop = this.$tabNav.scrollHeight - this.size - 37;
          }
        } else {
          this.$nextBtn.style.display = "none";
          this.$prevBtn.style.display = "none";
          this.$tabNav.style.height = "initial";
          this.$tabNav.style.overflow = "initial";
        }
      } else {
        this.$tabNav.style.height = "initial";
        let widthTabNav = this.$tabNav.children.length * stepHeight;
        let widthForm = this.$form.offsetWidth;
        this.$tabNav.scrollLeft = widthTabNav - this.size - numStep * stepHeight > 0 ? numStep * stepHeight : this.$tabNav.scrollLeft;
        if (widthTabNav - 75 > this.$form.offsetWidth) {
          this.$root.$el.classList.add("tab");
          this.$nextBtn.style.display = "block";
          this.$prevBtn.style.display = "block";
          this.size = (Math.trunc(widthForm / stepHeight) - 1) * stepHeight - 70;
          this.$tabNav.style.width = this.size + "px";
          this.$tabNav.style.overflow = "hidden";
        } else {
          this.$nextBtn.style.display = "none";
          this.$prevBtn.style.display = "none";
          this.$tabNav.style.width = "initial";
          this.$tabNav.style.overflow = "initial";
        }
      }
    }
  }
  scrollLeft() {
    this.$tabNav.scrollTo({
      left: this.$tabNav.scrollLeft - 115 > 0 ? Math.trunc(this.$tabNav.scrollLeft - 115) : 0,
      behavior: "smooth"
    });
  }
  scrollRight() {
    let widthTabNav = this.$tabNav.children.length * 115;
    this.$tabNav.scrollTo({
      left: widthTabNav - this.size - (this.$tabNav.scrollLeft + 115) > 0 ? Math.trunc(this.$tabNav.scrollLeft + 115) : this.$tabNav.scrollLeft,
      behavior: "smooth"
    });
  }
  scrollTop() {
    this.$tabNav.scrollTo({
      top: this.$tabNav.scrollTop - 115 > 35 ? Math.trunc(this.$tabNav.scrollTop - 115) : 35,
      behavior: "smooth"
    });
  }
  scrollBottom() {
    if (this.$tabNav.scrollHeight - this.$tabNav.clientHeight - this.$tabNav.scrollTop >= 115) {
      this.$tabNav.scrollTo({
        top: this.$tabNav.scrollTop + 115 < this.$tabNav.scrollHeight - this.size ? Math.trunc(this.$tabNav.scrollTop + 115) + 1 : this.$tabNav.scrollHeight - this.size - 37,
        behavior: "smooth"
      });
    }
  }
  validation() {
    return true;
  }
}